import "./products.css";
import { Link } from "react-router-dom";
import { useState } from "react";
import BuyModal from "./buyModal";

function Product(props) {
  const [modalShow, setModalShow] = useState(false);
  return (
    <div className="product">
    <img className="imageProduct" src={props.image && props.image}  alt={props.image} />
      <Link to={`/shop/detail/Produit/${props.id}`} className={props.name.length < 18 ?"nameProduct" : "nameProductbig"} >
        {props.name}
      </Link>
      <div className="priceProduct"> {props.price} DT </div>
      <div className="stock">
        {" "}
        <div
          variant="primary"
          onClick={() => {
            setModalShow(true);
          }}
        >
          Acheter
        </div>
        <BuyModal
          name={props.name}
           image={props.image} 
           item={props.item}
          price={props.price}
          show={modalShow}
          onHide={() => setModalShow(false)}
        />{" "}
      </div>
    </div>
  );
}
export default Product;
